import { useState } from 'react';

import { AccordionContent } from './accordion-content';
import { AccordionHeader } from './accordion-header';

interface AccordionProps {
  index: number;
  onHeaderClick?: () => void;
  header: () => JSX.Element;
  children: React.ReactNode;
  disabled?: boolean;
  classNames?: string;
  bgColor?: string;
  headerBgColor?: string;
  defaultOpen?: boolean;
}

export const MultiOpenAccordion = ({
  onHeaderClick,
  header,
  children,
  disabled = false,
  classNames,
  bgColor,
  headerBgColor,
  defaultOpen,
}: AccordionProps) => {
  const [opened, setOpened] = useState(defaultOpen ?? false);

  const handleClick = () => {
    if (!disabled) {
      setOpened((prev) => !prev);
    }
    if (onHeaderClick) {
      onHeaderClick();
    }
  };

  return (
    <div className="shadow mb-4 rounded-md">
      <AccordionHeader
        open={opened}
        onClick={handleClick}
        header={header}
        disabled={disabled}
        classNames={classNames}
        headerBgColor={headerBgColor}
      ></AccordionHeader>
      <AccordionContent open={opened} bgColor={bgColor}>
        {children}
      </AccordionContent>
    </div>
  );
};
